import Vue from 'vue'
import Router from 'vue-router'
import Index from '@/view/index/index'
import Goods from '@/view/goods/goods'
import Brand from '@/view/brand/ppzx'
import Ppxq from '@/view/brand/ppxq'
import Faster from '@/view/faster/faster'
import Login from '@/view/login/login'
import Bindtel from '@/view/login/bindtel'
import Register from '@/view/login/registergr'
import Forget from '@/view/login/wjmm'
import Cart from '@/view/cart/cart'
import GoodsDetail from '@/view/goods/goodsDetail'
import PersonalData from '@/view/member/personal_data'
import Collect from '@/view/member/collect'
import Address from '@/view/member/address'
import Safety from '@/view/member/safety'
import Historys from '@/view/member/historys'
import MyOrder from '@/view/member/my_order'
import PreOrderList from '@/view/member/preorder_list'
import MyPreOrder from '@/view/member/preorder'
import OrderDetail from '@/view/member/order_detail'
import ConfirmOrder from '@/view/cart/confirmOrder'
import Search from '@/view/search/search'
import News from '@/view/news/index'
import NewsDetail from '@/view/news/news_detail'
import About from '@/view/about/index'
import Supplier from '@/view/about/supplier'
import Honor from '@/view/honor/honor'
import Inquiry from '@/view/member/inquiry'
import Hotcake from '@/view/goods/hotcake'
import Ledcontrol from '@/view/led/ledcontrol'
import LedcontrolEdit from '@/view/led/ledcontrol_edit'
import ToPay from '@/view/cart/toPay'
import Statistics from '@/view/statistics/statistics'
import Scenearea from '@/view/scenearea/index'
import Flashsale from '@/view/flashsale/index'
import Service from '@/view/service/index'
import Scenehall from '@/view/scenehall/index'
import Member from '@/view/member/index'
import Help from '@/view/help/index'
import Password from '@/view/help/password'
import Agreement from '@/view/help/agreement'
import Privacy from '@/view/help/privacy'
import Complaint from '@/view/help/complaint'
import Placeorder from '@/view/help/placeorder'
import Howinqu from '@/view/help/howinqu'
import Howpay from '@/view/help/pay'
import Orderprogress from '@/view/help/orderprogress'
import Exportprint from '@/view/help/exportprint'
import Pricedesc from '@/view/help/pricedesc'
import Returngoods from '@/view/help/returngoods'
import Freight from '@/view/help/freight'
import Shiptime from '@/view/help/shiptime'
import Inspection from '@/view/help/inspection'
import Bill from '@/view/help/bill'
import Addressmanag from '@/view/help/address'
import LedIntroduce from '@/view/led/led_introduce'
import Contactus from '@/view/help/contactus'
import Resources from '@/view/resources/index'
import IndustryList from '@/view/resources/industry_list'
import InfoList from '@/view/resources/info_list'
import InfoDetail from '@/view/resources/info_detail'
import Sitemap from '@/view/sitemap/index'
import SearchList from '@/view/resources/search_list'
import Classify from '@/view/classify/index'
import Quotationsd from '@/view/enquiry/quotationsd'
import Repair from '@/view/repair/index'
import RepairDetail from '@/view/repair/repair_detail'
import Energy from '@/view/energy/index'
import Interthings from '@/view/interthings/index'
import Dynamic from '@/view/dynamic/Dynamic'
import DynamicDate from '@/view/dynamic/DynamicDate'
import ExpenseAccount from '@/view/member/expense_account'
import Finance from '@/view/member/finance'
import TaskAllocation from '@/view/member/taskAllocation'
import QuotationList from '@/view/member/quotation_list'
import Workdiary from '@/view/member/workdiary'
import BusinessOrders from '@/view/member/business_orders'
import TaskDistribution from '@/view/member/taskDistribution'
Vue.use(Router)

// 获取原型对象上的push函数
const originalPush = Router.prototype.push
// 修改原型对象中的push方法
Router.prototype.push = function push (location) {
  return originalPush.call(this, location).catch(err => err)
}
export default new Router({
  // mode: 'history',
  scrollBehavior (to, from, saveTop) {
    if (saveTop) {
      return saveTop
    } else {
      return {x: 0, y: 0}
    }
  },
  routes: [
    {
      path: '/',
      name: 'Index',
      component: Index
    },
    {
      path: '/Goods',
      name: 'Goods',
      component: Goods
    },
    {
      path: '/Brand',
      name: 'Brand',
      component: Brand
    },
    {
      path: '/Ppxq',
      name: 'Ppxq',
      component: Ppxq
    },
    {
      path: '/Faster',
      name: 'Faster',
      component: Faster
    },
    {
      path: '/Login',
      name: 'Login',
      component: Login
    },
    {
      path: '/Bindtel',
      name: 'Bindtel',
      component: Bindtel
    },
    {
      path: '/Register',
      name: 'Register',
      component: Register
    },
    {
      path: '/Forget',
      name: 'Forget',
      component: Forget
    },
    {
      path: '/Cart',
      name: 'Cart',
      component: Cart
    },
    {
      path: '/GoodsDetail',
      name: 'GoodsDetail',
      component: GoodsDetail
    },
    {
      path: '/PersonalData',
      name: 'PersonalData',
      component: PersonalData
    },
    {
      path: '/Collect',
      name: 'Collect',
      component: Collect
    },
    {
      path: '/Historys',
      name: 'Historys',
      component: Historys
    },
    {
      path: '/Address',
      name: 'Address',
      component: Address
    },
    {
      path: '/Safety',
      name: 'Safety',
      component: Safety
    },
    {
      path: '/MyOrder',
      name: 'MyOrder',
      component: MyOrder
    },
    {
      path: '/OrderDetail',
      name: 'OrderDetail',
      component: OrderDetail
    },
    {
      path: '/ConfirmOrder',
      name: 'ConfirmOrder',
      component: ConfirmOrder
    },
    {
      path: '/Search',
      name: 'Search',
      component: Search
    },
    {
      path: '/News',
      name: 'News',
      component: News
    },
    {
      path: '/NewsDetail',
      name: 'NewsDetail',
      component: NewsDetail
    },
    {
      path: '/About',
      name: 'About',
      component: About
    },
    {
      path: '/Supplier',
      name: 'Supplier',
      component: Supplier
    },
    {
      path: '/PreOrderList',
      name: 'PreOrderList',
      component: PreOrderList
    },
    {
      path: '/MyPreOrder',
      name: 'MyPreOrder',
      component: MyPreOrder
    },
    {
      path: '/Honor',
      name: 'Honor',
      component: Honor
    },
    {
      path: '/Inquiry',
      name: 'Inquiry',
      component: Inquiry
    },
    {
      path: '/Hotcake',
      name: 'Hotcake',
      component: Hotcake
    },
    {
      path: '/Ledcontrol',
      name: 'Ledcontrol',
      component: Ledcontrol
    },
    {
      path: '/LedcontrolEdit',
      name: 'LedcontrolEdit',
      component: LedcontrolEdit
    },
    {
      path: '/ToPay',
      name: 'ToPay',
      component: ToPay
    },
    {
      path: '/Statistics',
      name: 'Statistics',
      component: Statistics
    },
    {
      path: '/Scenearea',
      name: 'Scenearea',
      component: Scenearea
    },
    {
      path: '/Flashsale',
      name: 'Flashsale',
      component: Flashsale
    },
    {
      path: '/Service',
      name: 'Service',
      component: Service
    },
    {
      path: '/Scenehall',
      name: 'Scenehall',
      component: Scenehall
    },
    {
      path: '/Member',
      name: 'Member',
      component: Member
    },
    {
      path: '/Help',
      name: 'Help',
      component: Help
    },
    {
      path: '/Password',
      name: 'Password',
      component: Password
    },
    {
      path: '/Agreement',
      name: 'Agreement',
      component: Agreement
    },
    {
      path: '/Privacy',
      name: 'Privacy',
      component: Privacy
    },
    {
      path: '/Complaint',
      name: 'Complaint',
      component: Complaint
    },
    {
      path: '/Placeorder',
      name: 'Placeorder',
      component: Placeorder
    },
    {
      path: '/Howinqu',
      name: 'Howinqu',
      component: Howinqu
    },
    {
      path: '/Howpay',
      name: 'Howpay',
      component: Howpay
    },
    {
      path: '/Orderprogress',
      name: 'Orderprogress',
      component: Orderprogress
    },
    {
      path: '/Exportprint',
      name: 'Exportprint',
      component: Exportprint
    },
    {
      path: '/Pricedesc',
      name: 'Pricedesc',
      component: Pricedesc
    },
    {
      path: '/Returngoods',
      name: 'Returngoods',
      component: Returngoods
    },
    {
      path: '/Freight',
      name: 'Freight',
      component: Freight
    },
    {
      path: '/Shiptime',
      name: 'Shiptime',
      component: Shiptime
    },
    {
      path: '/Inspection',
      name: 'Inspection',
      component: Inspection
    },
    {
      path: '/Bill',
      name: 'Bill',
      component: Bill
    },
    {
      path: '/Addressmanag',
      name: 'Addressmanag',
      component: Addressmanag
    },
    {

      path: '/LedIntroduce',
      name: 'LedIntroduce',
      component: LedIntroduce
    },
    {
      path: '/Contactus',
      name: 'Contactus',
      component: Contactus
    },
    {
      path: '/Resources',
      name: 'Resources',
      component: Resources
    },
    {
      path: '/IndustryList',
      name: 'IndustryList',
      component: IndustryList
    },
    {
      path: '/InfoList',
      name: 'InfoList',
      component: InfoList
    },
    {
      path: '/InfoDetail',
      name: 'InfoDetail',
      component: InfoDetail
    },
    {
      path: '/Sitemap',
      name: 'Sitemap',
      component: Sitemap
    },
    {
      path: '/SearchList',
      name: 'SearchList',
      component: SearchList
    },
    {
      path: '/Classify',
      name: 'Classify',
      component: Classify
    },
    {
      path: '/Quotationsd',
      name: 'Quotationsd',
      component: Quotationsd
    },
    {
      path: '/Repair',
      name: 'Repair',
      component: Repair
    },
    {
      path: '/RepairDetail',
      name: 'RepairDetail',
      component: RepairDetail
    },
    {
      path: '/Energy',
      name: 'Energy',
      component: Energy
    },
    {
      path: '/Interthings',
      name: 'Interthings',
      component: Interthings
    },
    {
      path: '/Dynamic',
      name: 'Dynamic',
      component: Dynamic
    },
    {
      path: '/DynamicDate',
      name: 'DynamicDate',
      component: DynamicDate
    },
    {
      path: '/ExpenseAccount',
      name: 'ExpenseAccount',
      component: ExpenseAccount
    },
    {
      path: '/Finance',
      name: 'Finance',
      component: Finance
    },
    {
      path: '/TaskAllocation',
      name: 'TaskAllocation',
      component: TaskAllocation
    },
    {
      path: '/QuotationList',
      name: 'QuotationList',
      component: QuotationList
    },
    {
      path: '/Workdiary',
      name: 'Workdiary',
      component: Workdiary
    },
    {
      path: '/BusinessOrders',
      name: 'BusinessOrders',
      component: BusinessOrders
    },
    {
      path: '/TaskDistribution',
      name: 'TaskDistribution',
      component: TaskDistribution
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js